import { Collapse } from './Collapse';

export default {
    when() {
        return document.querySelectorAll('.slider--segments').length > 0;
    },
    mounted() {
        // $('.slider--segments').on('afterChange', function(event, slick, currentSlide) {
        //     const newSlideElement = slick.$slides[currentSlide];

        //     // If the new slide contains a collapse-toggle, attach a Collapse instance
        //     const collapseToggle = newSlideElement.querySelector('.collapse-toggle');

        //     if (collapseToggle) {
        //         const newInstance = new Collapse(collapseToggle, collapseToggle.dataset);

        //         // Check if there's any open collapse and open the new instance if needed
        //         const openCollapse = document.querySelector('.collapse-is-open');

        //         if (openCollapse) {
        //             newInstance.open();
        //         }
        //     }

        //     const clonedSlides = slick.$slider.find('.slick-cloned');
        //     console.log('-> afterChange', clonedSlides);

        //     if ($('.slider--segments').hasClass('collapse-are-open')) {
        //         clonedSlides.each(function() {
        //             const collapse = $(this).find('.collapse');
        //             const maxHeight = collapse.attr('data-max-height');
        //             collapse.find('.segments__bottom').css({
        //                 height: maxHeight + 'px',
        //             });
        //         });
        //     } else {
        //         clonedSlides.each(function() {
        //             const collapse = $(this).find('.collapse');
        //             collapse.find('.segments__bottom').css({
        //                 height: '0px',
        //             });
        //         });
        //     }
        // });

        $('.slider--segments').slick({
            autoplay: false,
            // autoplaySpeed: 5000,
            infinite: false,
            nextArrow: '<div class="btn--arrow btn--arrow--next"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z" fill="#FFB423"/><path d="M27.375 16.3281L35.625 24.2031C35.8594 24.4375 36 24.7188 36 25.0469C36 25.3281 35.8594 25.6094 35.625 25.8438L27.375 33.7188C26.9531 34.1406 26.2031 34.1406 25.7812 33.6719C25.3594 33.25 25.3594 32.5 25.8281 32.0781L32.0625 26.1719H16.125C15.4688 26.1719 15 25.6562 15 25.0469C15 24.3906 15.4688 23.9219 16.125 23.9219H32.0625L25.8281 17.9688C25.3594 17.5469 25.3594 16.7969 25.7812 16.375C26.2031 15.9062 26.9062 15.9062 27.375 16.3281Z" fill="white"/></svg></div>',
            prevArrow: '<div class="btn--arrow btn--arrow--prev"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z" fill="#FFB423"/><path d="M35.9531 25C35.9531 25.6562 35.4375 26.1719 34.8281 26.1719H18.8906L25.125 32.0781C25.5938 32.5 25.5938 33.25 25.1719 33.6719C24.75 34.1406 24.0469 34.1406 23.5781 33.7188L15.3281 25.8438C15.0938 25.6094 15 25.3281 15 25C15 24.7188 15.0938 24.4375 15.3281 24.2031L23.5781 16.3281C24.0469 15.9062 24.75 15.9062 25.1719 16.375C25.5938 16.7969 25.5938 17.5469 25.125 17.9688L18.8906 23.875H34.8281C35.4844 23.875 35.9531 24.3906 35.9531 25Z" fill="white"/></svg></div>',
            responsive: [
                {
                    breakpoint: 850,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        centerPadding: '14px',
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        centerPadding: '14px',
                        slidesToShow: 2,
                    },
                },
            ],
            slidesToScroll: 1,
            slidesToShow: 3,
        });

        let isBusy = false;

        // when opening collapse, open all
        document.addEventListener('collapseOpening', (e) => {
            const instance = e.detail.instance;

            if (instance.container && !isBusy) {
                isBusy = true;

                // Determine the maximum height among all the collapse contents
                let maxHeight = 0;
                const collapseContents = instance.container.querySelectorAll('.segments__bottom');
                collapseContents.forEach((content) => {
                    if (content.scrollHeight > maxHeight) {
                        maxHeight = content.scrollHeight;
                    }
                });

                // Set the maximum height to all collapse contents
                const allCollapse = instance.container.querySelectorAll('.collapse');
                allCollapse.forEach((element) => {
                    element.dataset.maxHeight = maxHeight;
                });

                instance.container.querySelectorAll('.collapse-toggle').forEach((button) => {
                    const instance = Collapse.getInstance(button);
                    instance.open();
                });
                setTimeout(() => isBusy = false);
            }

            instance.container.classList.add('collapse-are-open');
        });

        // when closing collapse, close all
        document.addEventListener('collapseClosing', (e) => {
            const instance = e.detail.instance;

            if (instance.container && !isBusy) {
                isBusy = true;

                //instance.container.querySelectorAll('.segments__bottom')

                instance.container.querySelectorAll('.collapse-toggle').forEach((button) => {
                    const instance = Collapse.getInstance(button);
                    instance.close();
                });
                setTimeout(() => isBusy = false);
            }

            instance.container.classList.remove('collapse-are-open');
        });
    },
}
